<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" v-if="addNewDataSidebar"/>

    <vs-table v-if="permissions_list" ref="tables" pagination :max-items="itemsPerPage" search :data="lists" class="table-fixed" style="width:100%">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <!-- <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown> -->

          <!-- ADD NEW -->
          <vs-button :size="largeScreenWidth ? '' : 'small' " color="primary" type="filled" @click="addNewData" v-if="permissions_create" icon="icon-plus" icon-pack="feather">Add New</vs-button>
          <!-- <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary btn-sm" @click="addNewData" v-if="permissions_create">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div> -->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown :disabled="lists.length == 0" vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span v-if="lists.length > 0" class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ lists.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : lists.length }} of {{ queriedItems }}</span>
            <span v-else>0 of 0</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th width="17%" sort-key="groupid">Group A</vs-th>
        <vs-th width="17%" sort-key="action_to_groupid">Group B</vs-th>
        <vs-th>Permissions</vs-th>
        <vs-th width="7%">Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody style="width:100%">
            <vs-tr style="width:100%" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              
              <vs-td style="width:25%">
                <p class="groupid">{{ groupName(tr.groupid) }}</p>
              </vs-td>
              <vs-td style="width:25%">
                <p class="action_to_groupid">{{ groupName(tr.action_to_groupid) }}</p>
              </vs-td>
              <vs-td style="width:45%" class="permissions">
                <!-- <vs-select multiple v-model="(tr.permissions).split(',')" label="Permission" class="w-full mb-2" >
                  <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in options" />
                </vs-select> -->
                <p>{{ permission_text(tr.permissions) }}</p>
              </vs-td>
              

              <vs-td class="whitespace-no-wrap" style="text-align: center;width:5%">
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 text-danger stroke-current" @click.stop="delete_this(tr)" />
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    <h5 v-else>Not allowed to view user list</h5>
  </div>
</template>

<script>
import DataViewSidebar from './sidebar.vue'
// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {
      // selected: [],
      lists: [],
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},

      options: [
        {
          id:'011',
          name: 'create_user'
        },
        {
          id:'012',
          name: 'read_user'
        },
        {
          id:'013',
          name: 'update_user'
        },
        {
          id:'014',
          name: 'delete_user'
        },
        {
          id:'021',
          name: 'create_customer'
        },
        {
          id:'022',
          name: 'read_customer'
        },
        {
          id:'023',
          name: 'update_customer'
        },
        {
          id:'024',
          name: 'delete_customer'
        },
        {
          id:'031',
          name: 'create_loan'
        },
        {
          id:'032',
          name: 'read_loan'
        },
        {
          id:'033',
          name: 'edit_loan'
        },
        {
          id:'034',
          name: 'delete_loan'
        },
      ],
    }
  },
  computed: {
    largeScreenWidth(){
      if(window.innerWidth > 575){
        return true
      }
      else
        return false
    },
    currentPage () {
      return this.$refs.tables.currentx
    },
    permissions () {
      if(this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.permissions){
        return this.$store.state.AppActiveUser.permissions;
      }
      else{
        return []
      }
    },
    permissions_create(){
      if( this.permissions.includes('*') || this.permissions.includes('011')){
        return true
      }
      else{
        return false
      }
    },
    permissions_list(){
      if( this.permissions.includes('*') || this.permissions.includes('012')){
        return true
      }
      else{
        return false
      }
    },
    permissions_update(){
      if( this.permissions.includes('*') || this.permissions.includes('013')){
        return true
      }
      else{
        return false
      }
    },
    permissions_delete(){
      if( this.permissions.includes('*') || this.permissions.includes('014')){
        return true
      }
      else{
        return false
      }
    },
    users () {
      return this.$store.state.userManagement.users
    },
    user_info(){
      let data = JSON.parse(sessionStorage.getItem('userInfo'));
      return data
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.lists.length
    },
    groupid_list(){
      let self = this
      let temp = []

      this.users.forEach(function(item){
        if(item.role !== 'WORKER'){
          temp.push({
            groupid: item.groupid,
            name: item.name
          })
        }
      })
      
      return temp
    },
  },
  methods: {
    groupName(target){
      let temp = ''
      this.groupid_list.forEach(function(item){
        if(target == item.groupid){
          temp = item.name
        }
      })
      return temp
    },
    permission_text(text_string){
      let self = this
      console.log('text string', text_string)
      if(text_string !== ''){
        let text = []
        let temp = text_string.split(',')
        console.log(temp)
        temp.forEach(function(item){
          self.options.forEach(function(inner){
            // console.log(item, inner)
            if(item == inner.id){
              text.push(inner.name)
            }
          })
        })
        return text.toString()
      }
      else{
        return ''
      }
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    showSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Group Permission',
        text: 'Permission group successfully deleted'
      })
    },
    delete_this (data) {
      let self = this
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm delete?',
        text: `Are you sure to delete this permissions?`,
        acceptText: 'Yes',
        accept: function(){
          self.$vs.loading()
          const baseURI = 'group_groups/'+data.id
          
          self.$http.delete(baseURI)
          .then((result) => {
            if(result.data.status == 'success'){
              console.log(result.data.data)
              self.$vs.loading.close()
              self.showSuccess()
              self.loadlist()
            }
            else{
              self.$vs.loading.close()
            }
          })
          .catch((err) => {
            if(err.logout){
              self.$vs.loading.close()
              self.$vs.notify({
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger',
                title: err.msg
              })
              sessionStorage.removeItem('accessToken')
              sessionStorage.removeItem('user')
              sessionStorage.removeItem('loan_info')
              this.$router.push('/pages/login').catch(() => {})
            }
          })
        }
      })
    },
    // editData (data) {
    //   // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
    //   this.sidebarData = data
    //   this.toggleDataSidebar(true)
    // },
    toggleDataSidebar (val = false) {
      let self = this
      this.addNewDataSidebar = val
      if(!val){
        self.$vs.loading()
        setTimeout(function(){
          self.$vs.loading.close()
          self.loadlist()
        },400)
        
      }
      // this.$store.dispatch("userManagement/fetchUsers")
    },
    loadlist(){
      let self
      this.$vs.loading()
      const baseURI = 'group_groups/list'
      // let formData = ''
      // if(this.user_info.role !== 'SUPERADMIN' || this.user_info.role !== 'DEVELOPER'){
      //   formData = new FormData();
      //   formData.append('status', 'ACTIVE,COMPLETE');
      // }
      
      this.$http.post(baseURI)
      .then((result) => {
        this.$vs.loading.close()
        if(result.data.status == 'success'){
          console.log(result.data.data)
          
          this.lists = result.data.data
        }
      })
      .catch((err) => {
        if(err.logout){
          this.$vs.loading.close()
          this.$vs.notify({
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            title: err.msg
          })
          sessionStorage.removeItem('accessToken')
          sessionStorage.removeItem('user')
          sessionStorage.removeItem('loan_info')
          this.$router.push('/pages/login').catch(() => {})
        }
      })
    }
  },
  created () {
    let self = this
    if(this.permissions_list){
      setTimeout(function(){
        self.loadlist()
      },200)
      
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */

    &.table-fixed .vs-table{
      table-layout:fixed;
    }

    &.table-fixed .permissions{
      word-wrap:break-word
    }

    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }

      &.table-fixed .vs-table{
        table-layout:auto;
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
